import PropTypes from 'prop-types'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Box from '@material-ui/core/Box'
import Right from '@material-ui/icons/KeyboardArrowRight'
import Left from '@material-ui/icons/KeyboardArrowLeft'
import { useTheme } from '@material-ui/core/styles'
import { PaginationStyles } from './pagination-new.styles'

const PaginationNew = (props) => {
  const theme = useTheme()
  const small = useMediaQuery(theme.breakpoints.only('xs'))

  return (
    <Box pt={[4, 6, 8]}>
      <PaginationStyles
        {...props}
        reduced={small}
        size={small ? 'small' : 'medium'}
        otherPageColor="inherit"
        currentPageColor="secondary"
        previousPageLabel={<Left aria-label="previous page" />}
        nextPageLabel={<Right aria-label="next page" />}
        aria-label="pagination container"
      />
    </Box>
  )
}

PaginationNew.propTypes = {
  width: PropTypes.string,
}

PaginationNew.defaultProps = {}

export default PaginationNew
